module.exports = __webpack_public_path__ + "img/icwithdraw.ca7d6ac6.png";